import React, { Component } from 'react';
import ScrollIndicator from '../ui/ScrollIndicator';
import RectButton from '../ui/RectButton';
import style from './IntroWithButton.module.scss';
import { TweenLite, TimelineLite } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';

const plugins = [CSSPlugin];
let SplitText;

class IntroWithButton extends Component {
  splitTextRun = false;
  setThemeClass = color => {
    switch (color) {
      case 'blue':
        return `chapter-theme--blue`;
      case 'yellow':
        return `chapter-theme--yellow`;
      case 'green':
        return `chapter-theme--green`;
      default:
        return `chapter-theme--red`;
    }
  };

  componentDidMount() {
    if (typeof window !== 'undefined') {
      SplitText = require('../../lib/SplitText');
    }
    if (this.props.startHidden && this.props.show) {
      TweenLite.set(this.wrapper, { opacity: 1 });
    }

    this.runSplitText();

    const header = this.wrapper.querySelectorAll('.maskDownTitle');
    const subHeader = this.wrapper.querySelector('p');
    const button = this.wrapper.querySelector('.js-introButton');
    const kicker = this.wrapper.querySelector('h5');
    const rule = this.wrapper.querySelector('.ch-inner-rule');
    if (this.props.startHidden && !this.props.show) {
      // console.log('transitioning, so hide slider text');
      header && TweenLite.set(header, { y: '100%' });
      subHeader && TweenLite.set(subHeader, { y: '10%', autoAlpha: 0 });
      button && TweenLite.set(button, { y: '100%' });
      kicker && TweenLite.set(kicker, { y: '100%' });
      rule && TweenLite.set(rule, { scaleX: 0 });
      this.scrollIndicator &&
        TweenLite.set(this.scrollIndicator, { opacity: 0, y: 20 });
    }
  }

  runSplitText() {
    // console.log(this.props.title, 'try to run splittext');
    if (!this.props.doSplitText || this.splitTextRun) {
      // console.log(this.props.title, 'already run, dont');
      return;
    }
    // console.log(this.props.title, 'actually run it');
    this.splitTextRun = true;

    let splitWords;
    const splitTarget = this.wrapper.querySelector('h1');
    const splitText = new SplitText(splitTarget, {
      type: 'words',
      wordsClass: 'maskDownTitle',
    });

    if (typeof document !== 'undefined') {
      splitWords = splitTarget.querySelectorAll(`.maskDownTitle`);
    }
    const wrap = (el, wrapper) => {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    };

    splitWords.forEach(word => {
      let element;
      if (typeof document !== 'undefined') {
        element = document.createElement('div');
      }
      element.className = style.maskDownWrapper;
      wrap(word, element);
    });
  }
  componentDidUpdate(prevProps) {
    // if text Changes, have to run split text again
    if (
      this.props.title !== prevProps.title ||
      this.props.subtitle !== prevProps.subtitle
    ) {
      // console.log('text change hide text and run split text');
      this.splitTextRun = false;
      this.runSplitText();
      const header = this.wrapper.querySelectorAll('.maskDownTitle');
      const subHeader = this.wrapper.querySelector('p');
      const button = this.wrapper.querySelector('.js-introButton');
      const kicker = this.wrapper.querySelector('h5');
      const rule = this.wrapper.querySelector('.ch-inner-rule');
      // if (this.props.textTransitioning ) {
      // console.log('transitioning, so hide slider text');
      TweenLite.set(header, { y: '100%' });
      TweenLite.set(subHeader, { y: '10%', autoAlpha: 0 });
      TweenLite.set(button, { y: '100%' });
      TweenLite.set(kicker, { y: '100%' });
      TweenLite.set(rule, { scaleX: 0 });
      // }

      TweenLite.set(this.wrapper, { opacity: 1 });
    }
  }
  componentWillReceiveProps(nextProps) {
    // FPO enter and exit animations for this element

    if (this.props.startHidden && !this.props.show && nextProps.show) {
      // run split text before show
      this.runSplitText();
      // show
      // TweenLite.to(this.wrapper, 0.5, { opacity: 1 });

      // console.log('reveal text on change of show prop, nextProps.show true');
      const header = this.wrapper.querySelectorAll('.maskDownTitle');
      const subHeader = this.wrapper.querySelector('p');
      const button = this.wrapper.querySelector('.js-introButton');
      const kicker = this.wrapper.querySelector('h5');
      const rule = this.wrapper.querySelector('.ch-inner-rule');

      TweenLite.set(this.wrapper, { opacity: 1 });

      const duration = 0.78;
      const increment = 0.2;
      let delay = 0.0;

      const tl = new TimelineLite();
      if (kicker) {
        tl.to(
          kicker,
          duration,
          {
            y: '0%',
            ease: Quad.easeInOut,
          },
          (delay += increment)
        );
      }

      rule &&
        tl.to(
          rule,
          duration,
          {
            scaleX: 1,
            ease: Quad.easeInOut,
          },
          (delay += increment)
        );

      header &&
        tl.to(
          header,
          duration,
          {
            y: '0%',
            ease: Quad.easeInOut,
          },
          (delay += increment)
        );

      subHeader &&
        tl.to(
          subHeader,
          duration,
          {
            y: '0%',
            autoAlpha: 1,
            ease: Quad.easeInOut,
          },
          (delay += increment)
        );

      button &&
        tl.to(
          button,
          duration,
          {
            y: '0%',
            ease: Quad.easeOut,
          },
          delay
        );
      this.scrollIndicator &&
        TweenLite.to(this.scrollIndicator, duration, {
          opacity: 1,
          y: 0,
          delay: 0.5,
        });
    }
    if (this.props.startHidden && this.props.show && !nextProps.show) {
      // hide
      // console.log('hide text when next props show is false');
      const header = this.wrapper.querySelectorAll('.maskDownTitle');
      const subHeader = this.wrapper.querySelector('p');
      const button = this.wrapper.querySelector('.js-introButton');
      const kicker = this.wrapper.querySelector('h5');
      const rule = this.wrapper.querySelector('.ch-inner-rule');

      const duration = 0.6;
      const increment = 0.0;
      let delay = 0.0;

      {
        kicker &&
          TweenLite.to(kicker, duration, {
            y: '100%',
            ease: Quad.easeIn,
            delay: delay,
            onComplete: () => {
              TweenLite.set(this.wrapper, { opacity: 0 });
            },
          });
        delay += increment;
      }

      rule &&
        TweenLite.to(rule, duration * 0.5, {
          scaleX: 0,
          ease: Quad.easeOut,
          delay: delay,
        });
      delay += increment;
      header &&
        TweenLite.to(header, duration, {
          y: '100%',
          ease: Quad.easeOut,
          delay: delay,
        });
      delay += increment;
      subHeader &&
        TweenLite.to(subHeader, duration, {
          y: '10%',
          autoAlpha: 0,
          ease: Quad.easeOut,
          delay: delay,
        });
      delay += increment;
      button &&
        TweenLite.to(button, duration, {
          y: '100%',
          ease: Quad.easeOut,
          delay: delay,
        });

      this.scrollIndicator &&
        TweenLite.to(this.scrollIndicator, duration, {
          opacity: 0,
          y: 20,
          delay: 0.5,
        });
    }

    // text back on after chapter transition
    if (this.props.textExit && !nextProps.textExit) {
      // console.log('set text back on false textExit prop');
      const resetElements = [
        this.wrapper.querySelector('h1'),
        this.wrapper.querySelector('p'),
        this.wrapper.querySelector('.js-introButton'),
        this.wrapper.querySelector('h5'),
      ];
      resetElements.forEach(el => {
        if (el) {
          el.removeAttribute('style');
        }
      });
    }
    // text animate off for chapter click
    if (!this.props.textExit && nextProps.textExit) {
      // console.log('textExit so hide');
      // chapter exit text animation
      const header = this.wrapper.querySelector('h1');
      const subHeader = this.wrapper.querySelector('p');
      const button = this.wrapper.querySelector('.js-introButton');
      const kicker = this.wrapper.querySelector('h5');

      const tl = new TimelineLite();
      if (kicker) {
        TweenLite.to(kicker, 0.8, {
          css: {
            color: '#FFFFFF',
          },
          ease: Circ.easeInOut,
        });
      }

      tl.to(subHeader, 0.8, {
        opacity: 0,
        ease: Circ.easeInOut,
      })
        .to(
          button,
          0.8,
          {
            opacity: 0,
            ease: Circ.easeInOut,
          },
          `-=${0.8}`
        )
        .to(
          header,
          0.8,
          {
            css: {
              color: '#FFFFFF',
            },
            ease: Circ.easeInOut,
          },
          `-=${0.8}`
        );
    }
  }

  render() {
    const {
      title,
      path,
      kicker,
      buttonText,
      subtitle,
      colorTheme,
      scrollIndicator,
      handleClick,
      textWhite,
      noPad,
      scrollClass,
      scrollOffset,
      buttonCTA,
      index,
      startHidden,
      noMobileRule,
      noButton,
    } = this.props;

    return (
      <div
        ref={el => {
          this.wrapper = el;
        }}
        // chapter-info
        className={`intro-text ${style.infoWrapper} ${this.setThemeClass(
          colorTheme
        )} ${textWhite ? style.textWhite : ''} ${noPad ? style.noPad : ''} ${
          startHidden ? style.startHidden : ''
        } ${noMobileRule ? style.noMobileRule : ''}`}
      >
        {kicker && (
          <div className={style.maskWrap}>
            <h5>{kicker}</h5>
          </div>
        )}
        <div className={`${style.innerWrap}`}>
          <div className={`${style.maskWrap} ${style.ruleMask}`}>
            <span
              style={{ transformOrigin: '0 50%' }}
              className={`ch-inner-rule ${style.innerRule}`}
            />
          </div>
          {title && (
            <div className={style.titleWrapper}>
              <h1
                className={`splitText-${index}`}
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </div>
          )}

          {subtitle && (
            <div className={`${style.maskWrap} ${style.subtitleWrap}`}>
              <p dangerouslySetInnerHTML={{ __html: subtitle }} />
            </div>
          )}

          {path && !noButton && (
            <div className={style.maskWrap}>
              <div className="js-introButton">
                <RectButton
                  path={path}
                  buttonText={buttonText ? buttonText : 'Explore'}
                  handleClick={handleClick}
                />
              </div>
            </div>
          )}

          {scrollIndicator && (
            <div
              ref={el => {
                this.scrollIndicator = el;
              }}
            >
              <ScrollIndicator
                scrollClass={scrollClass}
                scrollOffset={scrollOffset}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default IntroWithButton;



// WEBPACK FOOTER //
// ./src/components/global/IntroWithButton.js